<sk-modal-content [title]="'label.dms.SelectFiles' | translate"
                  confirmByKeypress
                  (confirmed)="onSelect()"
                  (cancelled)="closeWithoutResult()"
                  (closed)="closeWithoutResult()"
                  [allowCancelIfChildFocused]="true"
                  [allowConfirmIfChildFocused]="true">

  <ng-container id="sk-modal-body">
    @if (siaUrl(); as url) {
      <iframe
        #siaIframe
        width="100%"
        height="100%"
        title="Sia"
        [src]="url | safeResourceUrl"
      ></iframe>
    } @else if (siaUrl() === undefined) {
      <iris-simple-loader></iris-simple-loader>
    } @else {
      <iris-empty-content-view
        [message]="'label.SiaNotAvailable'"
        [label]="'label.Error'">
      </iris-empty-content-view>
    }
  </ng-container>

  <ng-container id="sk-modal-footer-buttons">
    <sk-button
      [color]="'primary'"
      [label]="'label.Files' | translate"
      data-test="modal-footer-confirm-button"
      [disabled]="!hasSelectedFiles()"
      [loadingBtn]="selectedFilesUploading()"
      (click)="onSelect()"
    >
      <ng-template buttonPrefix>
        <i class="fas fa-check"></i>
        @if (hasSelectedFiles()) {
          {{ selectedFilesCount() }}
        }
      </ng-template>
    </sk-button>
  </ng-container>

</sk-modal-content>
